export interface MatchEvent {
  minute: number;
  type: "goal" | "yellow" | "red" | "sub" | "var" | "kickoff" | "half" | "end";
  team: "home" | "away" | "none";
  player: string;
  detail: string;
}

export interface MatchStats {
  possession: [number, number];
  shots: [number, number];
  shotsOnTarget: [number, number];
  corners: [number, number];
  fouls: [number, number];
  offsides: [number, number];
  passes: [number, number];
}

export interface Match {
  id: string;
  season: string;
  stage: string;
  round: string;
  date: string;
  time: string;
  timestamp: string;
  homeTeamId: string;
  awayTeamId: string;
  homeScore: number | null;
  awayScore: number | null;
  status: "live" | "upcoming" | "finished";
  minute: number | null;
  venue: string;
  referee: string;
  cover: string;
  preview: string;
  events: MatchEvent[];
  stats: MatchStats | null;
}

export const matches: Match[] = [
  {
    id: "m-live-01",
    season: "2025-26",
    stage: "联赛阶段",
    round: "第 8 轮",
    date: "2026-10-15",
    time: "03:00",
    timestamp: "2026-10-15T03:00:00",
    homeTeamId: "man-city",
    awayTeamId: "real-madrid",
    homeScore: 2,
    awayScore: 1,
    status: "live",
    minute: 67,
    venue: "伊蒂哈德球场",
    referee: "丹尼埃尔·奥尔萨托",
    cover: "https://readdy.ai/api/search-image?query=Dramatic%20night%20football%20stadium%20interior%20with%20bright%20floodlights%2C%20green%20pitch%20and%20blurred%20packed%20crowd%2C%20deep%20blue%20tones%2C%20cinematic%20wide%20angle%2C%20atmospheric%20haze%2C%20high%20contrast%20sports%20photography&width=1600&height=900&seq=ucl-match-cover-live-01&orientation=landscape",
    preview:
      "两支志在夺冠的球队正面碰撞，曼城在主场寻求控制节奏，皇家马德里则准备用反击制造杀机，比赛悬念一直保留到最后。",
    events: [
      { minute: 0, type: "kickoff", team: "none", player: "主裁判", detail: "比赛正式开始，双方均以最强阵容出战。" },
      { minute: 18, type: "goal", team: "home", player: "埃尔林·哈兰德", detail: "德布劳内右路传中，哈兰德前点甩头破门，曼城 1:0 领先。" },
      { minute: 34, type: "yellow", team: "away", player: "安东尼奥·吕迪格", detail: "战术犯规放倒反击中的哈兰德，被出示黄牌。" },
      { minute: 41, type: "goal", team: "away", player: "维尼修斯", detail: "皇马快速反击，维尼修斯左路内切低射远角扳平比分。" },
      { minute: 45, type: "half", team: "none", player: "主裁判", detail: "半场结束，双方 1:1 暂时战平。" },
      { minute: 52, type: "var", team: "home", player: "VAR 回看", detail: "VAR 检查曼城疑似手球，判定进球有效不予改判。" },
      { minute: 61, type: "goal", team: "home", player: "凯文·德布劳内", detail: "罗德里直塞，德布劳内禁区弧顶推射远角得手，曼城 2:1 再次领先。" },
      { minute: 67, type: "sub", team: "away", player: "裘德·贝林厄姆", detail: "皇马换人调整，加强前场冲击力。" },
    ],
    stats: {
      possession: [58, 42],
      shots: [13, 9],
      shotsOnTarget: [6, 4],
      corners: [7, 3],
      fouls: [8, 11],
      offsides: [2, 3],
      passes: [512, 388],
    },
  },
  {
    id: "m-live-02",
    season: "2025-26",
    stage: "联赛阶段",
    round: "第 8 轮",
    date: "2026-10-15",
    time: "03:00",
    timestamp: "2026-10-15T03:00:00",
    homeTeamId: "bayern",
    awayTeamId: "psg",
    homeScore: 1,
    awayScore: 1,
    status: "live",
    minute: 55,
    venue: "安联球场",
    referee: "马克·格罗宁",
    cover: "https://readdy.ai/api/search-image?query=Modern%20football%20stadium%20under%20bright%20night%20lights%20with%20red%20and%20blue%20crowd%20colors%2C%20wide%20green%20pitch%2C%20clear%20atmosphere%2C%20cinematic%20sports%20photography%2C%20high%20detail&width=1600&height=900&seq=ucl-match-cover-live-02&orientation=landscape",
    preview:
      "拜仁主场迎战巴黎圣日耳曼，两队中场对抗激烈，边路攻防转换速度极快，一次疏忽就可能决定比赛走向。",
    events: [
      { minute: 0, type: "kickoff", team: "none", player: "主裁判", detail: "比赛开始，双方展开对攻。" },
      { minute: 23, type: "goal", team: "home", player: "哈里·凯恩", detail: "点球命中，拜仁取得领先。" },
      { minute: 44, type: "goal", team: "away", player: "乌斯曼·登贝莱", detail: "登贝莱右路突破后传射入网，巴黎扳平。" },
      { minute: 46, type: "kickoff", team: "none", player: "主裁判", detail: "下半场开始，双方均未做人员调整。" },
    ],
    stats: {
      possession: [51, 49],
      shots: [10, 11],
      shotsOnTarget: [4, 5],
      corners: [4, 6],
      fouls: [9, 7],
      offsides: [1, 2],
      passes: [421, 406],
    },
  },
  {
    id: "m-up-01",
    season: "2025-26",
    stage: "联赛阶段",
    round: "第 8 轮",
    date: "2026-10-16",
    time: "03:00",
    timestamp: "2026-10-16T03:00:00",
    homeTeamId: "barcelona",
    awayTeamId: "inter",
    homeScore: null,
    awayScore: null,
    status: "upcoming",
    minute: null,
    venue: "诺坎普球场",
    referee: "斯拉夫科·文契奇",
    cover: "https://readdy.ai/api/search-image?query=Grand%20football%20stadium%20at%20dusk%20with%20warm%20lights%20and%20blue%20red%20crowd%20scarves%2C%20wide%20angle%20green%20field%2C%20atmospheric%20evening%20sky%2C%20cinematic%20sports%20photography&width=1600&height=900&seq=ucl-match-cover-up-01&orientation=landscape",
    preview:
      "巴萨主场对阵国际米兰，技术流与防守反击的经典对话。主队需要通过快速传递拉开空间，客队的定位球同样是重要武器。",
    events: [],
    stats: null,
  },
  {
    id: "m-up-02",
    season: "2025-26",
    stage: "联赛阶段",
    round: "第 8 轮",
    date: "2026-10-16",
    time: "03:00",
    timestamp: "2026-10-16T03:00:00",
    homeTeamId: "arsenal",
    awayTeamId: "man-utd",
    homeScore: null,
    awayScore: null,
    status: "upcoming",
    minute: null,
    venue: "酋长球场",
    referee: "克莱芒·图尔潘",
    cover: "https://readdy.ai/api/search-image?query=English%20football%20stadium%20at%20night%20with%20red%20and%20white%20crowd%2C%20bright%20floodlights%2C%20lush%20green%20pitch%2C%20dramatic%20wide%20shot%2C%20cinematic%20sports%20photography%2C%20high%20detail&width=1600&height=900&seq=ucl-match-cover-up-02&orientation=landscape",
    preview:
      "英超内战，两支球队风格鲜明。阿森纳控球细腻，曼联则依靠速度与反击，中场争夺将决定比赛节奏。",
    events: [],
    stats: null,
  },
  {
    id: "m-up-03",
    season: "2025-26",
    stage: "联赛阶段",
    round: "第 9 轮",
    date: "2026-10-17",
    time: "03:00",
    timestamp: "2026-10-17T03:00:00",
    homeTeamId: "real-madrid",
    awayTeamId: "bayern",
    homeScore: null,
    awayScore: null,
    status: "upcoming",
    minute: null,
    venue: "伯纳乌球场",
    referee: "安东尼·泰勒",
    cover: "https://readdy.ai/api/search-image?query=Huge%20modern%20football%20stadium%20bowl%20at%20night%20with%20white%20illuminated%20stands%2C%20green%20field%2C%20bright%20spotlights%2C%20panoramic%20view%2C%20cinematic%20sports%20photography&width=1600&height=900&seq=ucl-match-cover-up-03&orientation=landscape",
    preview:
      "欧冠经典对决再度上演，皇家马德里坐镇伯纳乌迎战拜仁慕尼黑，两支球队在淘汰赛历史上恩怨颇多。",
    events: [],
    stats: null,
  },
  {
    id: "m-up-04",
    season: "2025-26",
    stage: "联赛阶段",
    round: "第 9 轮",
    date: "2026-10-22",
    time: "03:00",
    timestamp: "2026-10-22T03:00:00",
    homeTeamId: "psg",
    awayTeamId: "man-city",
    homeScore: null,
    awayScore: null,
    status: "upcoming",
    minute: null,
    venue: "王子公园球场",
    referee: "弗朗索瓦·莱泰克西耶",
    cover: "https://readdy.ai/api/search-image?query=Paris%20football%20stadium%20at%20night%20with%20navy%20blue%20crowd%20and%20bright%20lights%2C%20green%20pitch%2C%20wide%20cinematic%20angle%2C%20atmospheric%20evening%20sky%2C%20sports%20photography&width=1600&height=900&seq=ucl-match-cover-up-04&orientation=landscape",
    preview:
      "巴黎主场迎战曼城，控球与压迫的正面对话。双方的边后卫压上幅度都很大，转换进攻的防守将成为关键。",
    events: [],
    stats: null,
  },
  {
    id: "m-fin-01",
    season: "2025-26",
    stage: "联赛阶段",
    round: "第 7 轮",
    date: "2026-10-08",
    time: "03:00",
    timestamp: "2026-10-08T03:00:00",
    homeTeamId: "inter",
    awayTeamId: "barcelona",
    homeScore: 2,
    awayScore: 2,
    status: "finished",
    minute: 90,
    venue: "梅阿查球场",
    referee: "伊万·克鲁兹利亚克",
    cover: "https://readdy.ai/api/search-image?query=Italian%20football%20stadium%20at%20night%20with%20blue%20and%20black%20crowd%2C%20bright%20floodlights%2C%20green%20pitch%2C%20wide%20cinematic%20shot%2C%20sports%20photography%2C%20high%20detail&width=1600&height=900&seq=ucl-match-cover-fin-01&orientation=landscape",
    preview:
      "国际米兰与巴塞罗那奉献了一场精彩的进球大战，双方在中场展开了高强度的拉锯，最终握手言和。",
    events: [
      { minute: 12, type: "goal", team: "home", player: "劳塔罗·马丁内斯", detail: "巴雷拉直塞，劳塔罗推射远角破门。" },
      { minute: 33, type: "goal", team: "away", player: "罗伯特·莱万多夫斯基", detail: "禁区内抢点破门，巴萨扳平。" },
      { minute: 58, type: "goal", team: "away", player: "拉明·亚马尔", detail: "右路内切世界波，巴萨反超。" },
      { minute: 88, type: "goal", team: "home", player: "尼科洛·巴雷拉", detail: "补时前远射折射入网，国米绝平。" },
      { minute: 90, type: "end", team: "none", player: "主裁判", detail: "全场比赛结束，2:2。" },
    ],
    stats: {
      possession: [47, 53],
      shots: [12, 14],
      shotsOnTarget: [5, 6],
      corners: [3, 5],
      fouls: [13, 10],
      offsides: [2, 1],
      passes: [398, 470],
    },
  },
  {
    id: "m-fin-02",
    season: "2025-26",
    stage: "联赛阶段",
    round: "第 7 轮",
    date: "2026-10-08",
    time: "03:00",
    timestamp: "2026-10-08T03:00:00",
    homeTeamId: "man-utd",
    awayTeamId: "arsenal",
    homeScore: 1,
    awayScore: 3,
    status: "finished",
    minute: 90,
    venue: "老特拉福德球场",
    referee: "西蒙·马尔齐尼亚克",
    cover: "https://readdy.ai/api/search-image?query=Historic%20English%20football%20stadium%20at%20night%20with%20mixed%20red%20crowd%2C%20bright%20floodlights%2C%20green%20pitch%2C%20wide%20cinematic%20angle%2C%20sports%20photography&width=1600&height=900&seq=ucl-match-cover-fin-02&orientation=landscape",
    preview:
      "酋长与老特拉福德的内战如期而至，阿森纳客场整体表现更为出色，凭借高效的反击拿下三分。",
    events: [
      { minute: 20, type: "goal", team: "away", player: "布卡约·萨卡", detail: "厄德高直塞，萨卡单刀破门。" },
      { minute: 44, type: "goal", team: "home", player: "布鲁诺·费尔南德斯", detail: "任意球直接破门，曼联扳平。" },
      { minute: 66, type: "goal", team: "away", player: "德克兰·赖斯", detail: "角球混战中补射入网。" },
      { minute: 84, type: "goal", team: "away", player: "马丁·厄德高", detail: "快速反击中推射锁定胜局。" },
      { minute: 90, type: "end", team: "none", player: "主裁判", detail: "全场结束，阿森纳客场 3:1 取胜。" },
    ],
    stats: {
      possession: [44, 56],
      shots: [9, 16],
      shotsOnTarget: [3, 8],
      corners: [4, 7],
      fouls: [12, 9],
      offsides: [3, 1],
      passes: [372, 508],
    },
  },
  {
    id: "m-fin-03",
    season: "2024-25",
    stage: "决赛",
    round: "决赛",
    date: "2025-05-31",
    time: "03:00",
    timestamp: "2025-05-31T03:00:00",
    homeTeamId: "psg",
    awayTeamId: "inter",
    homeScore: 2,
    awayScore: 0,
    status: "finished",
    minute: 90,
    venue: "慕尼黑安联球场",
    referee: "毛里齐奥·马里亚尼",
    cover: "https://readdy.ai/api/search-image?query=Champions%20league%20final%20stadium%20at%20night%20with%20confetti%20light%20beams%20and%20packed%20crowd%2C%20wide%20green%20pitch%2C%20epic%20atmosphere%2C%20cinematic%20sports%20photography&width=1600&height=900&seq=ucl-match-cover-final-01&orientation=landscape",
    preview:
      "欧冠决赛，巴黎圣日耳曼凭借下半场的两粒进球击败国际米兰，捧起队史首座欧冠奖杯。",
    events: [
      { minute: 0, type: "kickoff", team: "none", player: "主裁判", detail: "决赛正式开始。" },
      { minute: 52, type: "goal", team: "home", player: "乌斯曼·登贝莱", detail: "禁区弧顶抽射破门，巴黎取得领先。" },
      { minute: 78, type: "goal", team: "home", player: "维蒂尼亚", detail: "反击中远角推射入网，锁定胜局。" },
      { minute: 90, type: "end", team: "none", player: "主裁判", detail: "全场比赛结束，巴黎圣日耳曼夺得队史首冠。" },
    ],
    stats: {
      possession: [55, 45],
      shots: [15, 8],
      shotsOnTarget: [7, 2],
      corners: [6, 2],
      fouls: [10, 14],
      offsides: [1, 2],
      passes: [489, 366],
    },
  },
  {
    id: "m-fin-04",
    season: "2024-25",
    stage: "半决赛",
    round: "半决赛次回合",
    date: "2025-05-07",
    time: "03:00",
    timestamp: "2025-05-07T03:00:00",
    homeTeamId: "inter",
    awayTeamId: "barcelona",
    homeScore: 4,
    awayScore: 3,
    status: "finished",
    minute: 120,
    venue: "梅阿查球场",
    referee: "丹尼·马克利",
    cover: "https://readdy.ai/api/search-image?query=Football%20stadium%20at%20night%20with%20electric%20atmosphere%20and%20blue%20black%20crowd%2C%20bright%20lights%2C%20green%20pitch%2C%20wide%20cinematic%20angle%2C%20sports%20photography&width=1600&height=900&seq=ucl-match-cover-semi-01&orientation=landscape",
    preview:
      "一场载入史册的半决赛，国际米兰在加时赛中绝杀巴塞罗那，惊险晋级决赛。",
    events: [
      { minute: 21, type: "goal", team: "home", player: "劳塔罗·马丁内斯", detail: "国米先下一城。" },
      { minute: 45, type: "goal", team: "away", player: "佩德里", detail: "巴萨半场前扳平。" },
      { minute: 63, type: "goal", team: "home", player: "尼科洛·巴雷拉", detail: "国米再次超出。" },
      { minute: 88, type: "goal", team: "away", player: "拉明·亚马尔", detail: "补时阶段扳平，拖入加时。" },
      { minute: 112, type: "goal", team: "home", player: "劳塔罗·马丁内斯", detail: "加时绝杀，国米晋级。" },
      { minute: 120, type: "end", team: "none", player: "主裁判", detail: "比赛结束，国际米兰 4:3 胜出。" },
    ],
    stats: {
      possession: [46, 54],
      shots: [17, 13],
      shotsOnTarget: [9, 6],
      corners: [5, 4],
      fouls: [15, 11],
      offsides: [2, 3],
      passes: [402, 478],
    },
  },
  {
    id: "m-fin-05",
    season: "2023-24",
    stage: "决赛",
    round: "决赛",
    date: "2024-06-02",
    time: "03:00",
    timestamp: "2024-06-02T03:00:00",
    homeTeamId: "real-madrid",
    awayTeamId: "bayern",
    homeScore: 2,
    awayScore: 0,
    status: "finished",
    minute: 90,
    venue: "伦敦温布利球场",
    referee: "斯拉夫科·文契奇",
    cover: "https://readdy.ai/api/search-image?query=Iconic%20football%20stadium%20at%20night%20with%20white%20light%20beams%20and%20packed%20crowd%2C%20wide%20green%20pitch%2C%20epic%20final%20atmosphere%2C%20cinematic%20sports%20photography&width=1600&height=900&seq=ucl-match-cover-final-02&orientation=landscape",
    preview: "皇家马德里再度展现决赛统治力，凭借下半场的稳定发挥击败拜仁，第 15 次捧起欧冠奖杯。",
    events: [
      { minute: 0, type: "kickoff", team: "none", player: "主裁判", detail: "决赛开球。" },
      { minute: 58, type: "goal", team: "home", player: "维尼修斯", detail: "左路突破后破门，皇马领先。" },
      { minute: 76, type: "goal", team: "home", player: "裘德·贝林厄姆", detail: "后插上头球锁定胜局。" },
      { minute: 90, type: "end", team: "none", player: "主裁判", detail: "全场结束，皇家马德里夺冠。" },
    ],
    stats: {
      possession: [49, 51],
      shots: [13, 11],
      shotsOnTarget: [6, 3],
      corners: [5, 5],
      fouls: [11, 13],
      offsides: [2, 1],
      passes: [440, 459],
    },
  },
  {
    id: "m-up-05",
    season: "2025-26",
    stage: "联赛阶段",
    round: "第 9 轮",
    date: "2026-10-22",
    time: "03:00",
    timestamp: "2026-10-22T03:00:00",
    homeTeamId: "man-utd",
    awayTeamId: "inter",
    homeScore: null,
    awayScore: null,
    status: "upcoming",
    minute: null,
    venue: "老特拉福德球场",
    referee: "克莱门特·图尔潘",
    cover: "https://readdy.ai/api/search-image?query=Classic%20English%20football%20ground%20at%20night%20with%20red%20crowd%20and%20glowing%20floodlights%2C%20wide%20green%20pitch%2C%20cinematic%20visual%2C%20sports%20photography&width=1600&height=900&seq=ucl-match-cover-up-05&orientation=landscape",
    preview: "曼联主场迎来国际米兰，红魔需要在中场对抗中占据主动，国米的三中卫体系将是最大考验。",
    events: [],
    stats: null,
  },
  {
    id: "m-fin-06",
    season: "2023-24",
    stage: "8 强",
    round: "1/4 决赛次回合",
    date: "2024-04-18",
    time: "03:00",
    timestamp: "2024-04-18T03:00:00",
    homeTeamId: "man-city",
    awayTeamId: "real-madrid",
    homeScore: 1,
    awayScore: 1,
    status: "finished",
    minute: 120,
    venue: "伊蒂哈德球场",
    referee: "丹尼埃尔·奥尔萨托",
    cover: "https://readdy.ai/api/search-image?query=Large%20modern%20stadium%20at%20night%20with%20sky%20blue%20lighting%20and%20packed%20crowd%2C%20wide%20angle%20green%20pitch%2C%20dramatic%20atmosphere%2C%20sports%20photography&width=1600&height=900&seq=ucl-match-cover-qf-01&orientation=landscape",
    preview: "两回合鏖战至点球大战，皇家马德里惊险淘汰曼城，晋级半决赛。",
    events: [
      { minute: 12, type: "goal", team: "home", player: "凯文·德布劳内", detail: "曼城主场先进一球。" },
      { minute: 76, type: "goal", team: "away", player: "罗德里戈", detail: "皇马反击扳平，将比赛拖入加时。" },
      { minute: 120, type: "end", team: "none", player: "主裁判", detail: "加时无果，皇马点球大战胜出。" },
    ],
    stats: {
      possession: [63, 37],
      shots: [18, 7],
      shotsOnTarget: [8, 3],
      corners: [9, 2],
      fouls: [7, 12],
      offsides: [3, 2],
      passes: [601, 322],
    },
  },
  {
    id: "m-up-06",
    season: "2025-26",
    stage: "联赛阶段",
    round: "第 9 轮",
    date: "2026-10-17",
    time: "03:00",
    timestamp: "2026-10-17T03:00:00",
    homeTeamId: "inter",
    awayTeamId: "arsenal",
    homeScore: null,
    awayScore: null,
    status: "upcoming",
    minute: null,
    venue: "梅阿查球场",
    referee: "伊什特万·科瓦奇",
    cover: "https://readdy.ai/api/search-image?query=European%20football%20stadium%20at%20night%20with%20blue%20and%20black%20fans%20and%20bright%20floodlights%2C%20wide%20green%20pitch%2C%20cinematic%20visual%2C%20sports%20photography&width=1600&height=900&seq=ucl-match-cover-up-06&orientation=landscape",
    preview: "国际米兰主场对阵阿森纳，防守组织与定位球效率很可能成为决定比赛的关键因素。",
    events: [],
    stats: null,
  },
  {
    id: "m-fin-07",
    season: "2025-26",
    stage: "联赛阶段",
    round: "第 6 轮",
    date: "2026-09-30",
    time: "03:00",
    timestamp: "2026-09-30T03:00:00",
    homeTeamId: "bayern",
    awayTeamId: "barcelona",
    homeScore: 3,
    awayScore: 2,
    status: "finished",
    minute: 90,
    venue: "安联球场",
    referee: "安东尼·泰勒",
    cover: "https://readdy.ai/api/search-image?query=Big%20football%20stadium%20at%20night%20with%20red%20and%20blue%20crowd%2C%20bright%20spotlights%2C%20wide%20green%20pitch%2C%20cinematic%20view%2C%20sports%20photography%2C%20high%20detail&width=1600&height=900&seq=ucl-match-cover-fin-07&orientation=landscape",
    preview: "拜仁与巴萨上演进球大战，主队凭借最后时刻的进球险胜，比赛过程跌宕起伏。",
    events: [
      { minute: 9, type: "goal", team: "home", player: "哈里·凯恩", detail: "禁区内转身抽射破门。" },
      { minute: 27, type: "goal", team: "away", player: "拉明·亚马尔", detail: "远射世界波扳平。" },
      { minute: 55, type: "goal", team: "home", player: "贾马尔·穆西亚拉", detail: "连过两人后推射入网。" },
      { minute: 79, type: "goal", team: "away", player: "罗伯特·莱万多夫斯基", detail: "点球命中再次扳平。" },
      { minute: 90, type: "goal", team: "home", player: "哈里·凯恩", detail: "补时绝杀，拜仁 3:2 取胜。" },
      { minute: 90, type: "end", team: "none", player: "主裁判", detail: "比赛结束。" },
    ],
    stats: {
      possession: [52, 48],
      shots: [16, 12],
      shotsOnTarget: [8, 6],
      corners: [6, 4],
      fouls: [10, 9],
      offsides: [2, 2],
      passes: [455, 431],
    },
  },
  {
    id: "m-fin-08",
    season: "2025-26",
    stage: "联赛阶段",
    round: "第 6 轮",
    date: "2026-09-30",
    time: "03:00",
    timestamp: "2026-09-30T03:00:00",
    homeTeamId: "psg",
    awayTeamId: "man-utd",
    homeScore: 2,
    awayScore: 1,
    status: "finished",
    minute: 90,
    venue: "王子公园球场",
    referee: "马尔科·圭达",
    cover: "https://readdy.ai/api/search-image?query=Paris%20stadium%20at%20night%20with%20navy%20blue%20crowd%20and%20bright%20lights%2C%20wide%20green%20pitch%2C%20cinematic%20atmosphere%2C%20sports%20photography&width=1600&height=900&seq=ucl-match-cover-fin-08&orientation=landscape",
    preview: "巴黎主场小胜曼联，登贝莱贡献一传一射，成为全场最佳球员。",
    events: [
      { minute: 31, type: "goal", team: "home", player: "乌斯曼·登贝莱", detail: "右路内切远角破门。" },
      { minute: 64, type: "goal", team: "away", player: "马库斯·拉什福德", detail: "反击中低射扳平。" },
      { minute: 81, type: "goal", team: "home", player: "维蒂尼亚", detail: "登贝莱助攻，维蒂尼亚推射制胜。" },
      { minute: 90, type: "end", team: "none", player: "主裁判", detail: "比赛结束，巴黎 2:1 取胜。" },
    ],
    stats: {
      possession: [57, 43],
      shots: [14, 10],
      shotsOnTarget: [6, 4],
      corners: [7, 3],
      fouls: [8, 12],
      offsides: [2, 3],
      passes: [501, 372],
    },
  },
];